import { useEffect } from 'react';
import autoLockService from '../components/AutoLockService';

export const useAutoLockService = () => {
  useEffect(() => {
    // Start the auto-lock service when the hook is used
    autoLockService.start();

    // Cleanup function to stop the service when the component unmounts
    return () => {
      // Note: We don't stop the service here because multiple components might be using it
      // The service will be stopped when the app is closed or when explicitly stopped
    };
  }, []);

  return autoLockService;
};
